// exporting for testing
export function generateQueryParams(qParamsObj) {
  return Object.keys(qParamsObj || {}).reduce((previous, current, index) => {
    return `${previous}${!index ? '?' : '&'}${current}=${qParamsObj[current]}`;
  }, '');
}

export const loginUrl = qParams =>
  `/kma/api/security/doLogin${generateQueryParams(qParams)}`;
export const getAuthStateUrl = qParams =>
  `/kma/api/security/state${generateQueryParams(qParams)}`;
export const getSSOEndpointUrl = qParams =>
  `/kma/api/security/getSSOEndpointUrl${generateQueryParams(qParams)}`;

export default { loginUrl, getAuthStateUrl, getSSOEndpointUrl };



// WEBPACK FOOTER //
// ./src/utils/apiHelper.js